import { randomUUID } from '@/src/common/utils/randomUUID'
import { useMemo, type ComponentProps } from 'react'
import Svg, { Path, Filter, FeColorMatrix, Defs } from 'react-native-svg'

const Mortgage = (props: ComponentProps<typeof Svg> & { grayscale?: boolean }) => {
  const uniqueId = useMemo(() => randomUUID(), [])
  const filterId = `grayscale-${uniqueId}`
  const grayscale = props.grayscale ? `url(#${filterId})` : undefined

  return (
    <Svg width={63} height={63} viewBox="0 0 63 63" fill="none" {...props}>
      <Defs>
        <Filter id={filterId}>
          <FeColorMatrix type="saturate" values="0" />
        </Filter>
      </Defs>
      <Path
        d="M0 8a8 8 0 018-8h47a8 8 0 018 8v47a8 8 0 01-8 8H8a8 8 0 01-8-8V8z"
        fill="#C6FFF5"
        filter={grayscale}
      />
      <Path
        d="M19.5 28.833a2.666 2.666 0 01.945-2.037l9.334-7.999a2.666 2.666 0 013.442 0l9.334 7.999a2.668 2.668 0 01.945 2.037v12a2.667 2.667 0 01-2.667 2.667H22.167a2.667 2.667 0 01-2.667-2.667v-12z"
        fill="#00DFC9"
        stroke="#223843"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
        filter={grayscale}
      />
      <Path
        d="M35.5 42.636v-9.899c0-.328-.14-.643-.39-.875a1.388 1.388 0 00-.943-.362h-5.334c-.353 0-.692.13-.942.362-.25.232-.391.547-.391.875v9.899"
        fill="#C6FFF5"
        filter={grayscale}
      />
      <Path
        d="M35.5 42.636v-9.899c0-.328-.14-.643-.39-.875a1.388 1.388 0 00-.943-.362h-5.334c-.353 0-.692.13-.942.362-.25.232-.391.547-.391.875v9.899"
        stroke="#223843"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
        filter={grayscale}
      />
    </Svg>
  )
}

export default Mortgage
